<template>
  <main class="styles-app-structure-main">
    <section class="styles-app-structure-section">

      
      <div class="styles-app-structure-program" style="overflow: hidden; " :class="($route.params.event) ? 'styles-app-structure-split' : ''">
        <slider :id="1"/>
        <highlight-matches-carousel
            :matches="highlightMatches"
            :slides-to-show="3"
            :autoplay="true"
            :autoplay-interval="5000"
            @odd-selected="handleOddSelection"
            @view-more-markets="handleViewMoreMarkets"
          />
      </div>
    </section>
  </main>
</template>

<script>
import CarouselSlider from '@/components/sportsbook/widget/slider';
import promoSlide from '@/components/promotion/promoSlide';
import topRewards from '@/components/sportsbook/widget/topRewards';
import upcomingWidget from '@/components/sportsbook/widget/upcoming';
import playingWidget from '@/components/sportsbook/widget/playing';
import CompetitionSide from '@/components/sportsbook/CompetitionSide';
import BetSlip from '@/components/sportsbook/BetSlip';
import LiveMatches from "../sportsbook/LiveMatches";
import LiveUpcaming from "../sportsbook/liveUpcaming";
import statsInfo from '@/components/sportsbook/widget/statsInfo'
import supportInfo from '@/components/sportsbook/widget/supportInfo';
import recommendedLinks from '@/components/sportsbook/widget/recommendedLinks'
import mobileInfo from '@/components/sportsbook/widget/mobileinfo'
import liveCasinoBanner from '@/components/sportsbook/widget/liveCasinoBanner'
import eventSearch from '@/components/sportsbook/widget/eventSearch';
import matches from '@/components/sportsbook/matches';
import matchDetail from '@/components/sportsbook/matchDetail';

import quickLinks from "../widget/quickLinks";
import topCompetitions from "../widget/topCompetitions";
import TopSports from "../widget/topSports";
import timer from "../widget/timer";
import CountDownLoader from '@/components/sportsbook/countdownLoader'
import slider from "../widget/slider";
import HighlightMatchesCarousel from '../widget/highlightEventCarousel.vue';


export default {
  name: 'fixture',
  components: {
    HighlightMatchesCarousel,
    slider,
    CarouselSlider,
    CountDownLoader,
    matches,
    TopSports,
    timer,
    quickLinks,
    topCompetitions,
    eventSearch,
    liveCasinoBanner,
    topRewards,
    LiveUpcaming,
    LiveMatches,
    promoSlide,
    upcomingWidget,
    playingWidget,
    CompetitionSide,
    BetSlip,
    statsInfo,
    supportInfo,
    recommendedLinks,
    mobileInfo,
    matchDetail
  },
  data() {
    return {
      highlightMatches: [],
      compact: false,
      hovered: false,
    }
  },
  computed: {
    highlightedMatches() {
      // Filter only highlighted matches or return all
      return this.highlightMatches.filter(match => match.highlighted);
    }
  },
  mounted() {
    this.$nextTick(() => {
        this.$router.replace({name: 'Sportsbook'})
    })

    this.checkWindow();
    this.fetchMatches();

    window.addEventListener('resize', this.checkWindow);
  },
  methods: {
    async fetchMatches() {
      try {
        const response = await fetch(window.bsapi+'/api/v2/fixture/full?sport=1&region=&competition=&page=1&withBets=&upcoming=24+hours&highlighted=&match=&onLive=&isLive=&app=107&uid=0&onlyList=row&locale=de&listCompetitionFavourites=0');
        const data = await response.json();
        this.highlightMatches = data.result;
      } catch (error) {
        console.error('Error fetching matches:', error);
      }
    },
    
    handleOddSelection(data) {
      console.log('Odd selected:', data);
      // Add to bet slip or handle selection
    },
    
    handleViewMatch(matchId) {
      console.log('View match:', matchId);
      // Navigate to match detail page
      this.$router.push(`/match/${matchId}`);
    },
    checkWindow(w) {
      if(window.innerWidth < 1200){
        this.compact = true;
        this.$bus.$emit('compact', this.compact);
      }else {
        this.compact = false;
        this.$bus.$emit('compact', this.compact);
      }

    },
    clickCompact(){
      this.compact = (this.compact) ? false : true;

      this.$bus.$emit('compact', this.compact);
    },
    closeCompact(){
      this.compact = (this.compact) ? false : true;

      this.$bus.$emit('compact', this.compact);
    },
    hover () {

      if(this.compact){
        this.hovered = (this.hovered) ? false : true;

        var element = document.getElementById('sidebar');
        element.classList.add('styles-app-structure-hovered');

        this.$bus.$emit('compact', false);
      }

    },
    unhover () {

      if(this.compact){
        this.hovered = (this.hovered) ? false : true;

        var element = document.getElementById('sidebar');
        element.classList.remove('styles-app-structure-hovered');

        this.$bus.$emit('compact', true);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.app-container {
  display: flex;
}

.swiper-container img {
  width: 100%;
}

.swiper-slide {
  height: auto;
  background-size: 100%;
  background-position: top;
  background-repeat: no-repeat;
  &.slide-1 {
    background-image: url('/static/assets/img/slides/welcome_bonus.jpg');
  }
  &.slide-2 {
    background-image: url('/static/assets/img/slides/papara.jpg');
  }
  &.slide-3 {
    background-image: url('/static/assets/img/slides/cepbank.jpg');
  }
  &.slide-4 {
    background-image: url('/static/assets/img/slides/freebonus.jpg');
  }
  &.slide-5 {
    background-image: url('/static/assets/img/slides/norisk.jpg');
  }
  &.slide-6 {
    background-image: url('/static/assets/img/slides/payment_bonus.jpg');
  }
  &.slide-7 {
    background-image: url('/static/assets/img/slides/livecasino.jpg');
  }
}

.swiper-slide a {
  width: 100%;
  height: 100%;
  float: left;
}

.gallery-top {
  height: auto;
  width: 100%;
}

.gallery-thumbs {
  height: 140px;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active, .gallery-thumbs:hover {
  opacity: 1;
}

.styles-app-structure-resize-nav-tree {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue